<template>    
  <Toast />
    <div class="row">
        <div class="col">
            <h2 class="titre">Modification Billet</h2>
        </div>
    </div>
    <ModifierChamps ref="modifierChamps" :billet="billet" :isModifier="true"/>
    <ButtonBar @fermer="fermer" @sauvegarder="sauvegarder" :isSauvegardeEnCours="isSauvegardeEnCours"/>
    <DialogConfirmation ref="dialogConfirmation"/>     
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import ButtonBar from '../../../components/dossier/Modifier/ButtonBarBillet.vue'
import ModifierChamps from '../../../components/dossier/Modifier/ModifierChampsBillet.vue'
import DialogConfirmation from '../../../components/Commun/DialogConfirmation.vue'

export default {
  components: {
      ButtonBar,
      ModifierChamps,
      DialogConfirmation,
  },
  data() {
    return {
      isSauvegardeEnCours: false,
    };
  },
	computed: {
		...mapGetters({
            jeton: 'cardex/jeton',
      profil: 'cardex/profil',
            billet: 'billet/billet',
		})
  },
  mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Modifier un billet");
  },
  methods: {
    sauvegarder() {
        this.isSauvegardeEnCours = true;
        this.$store.commit('billet/UPDATE_BILLET', this.$refs.modifierChamps.getBilletLocal());
        this.$store.dispatch('billet/sauvegarderBilletAction', {
            cle: this.$route.params.cle,
            site: this.$route.params.site,
        }).then((res) =>{
            this.$root.$refs.messagesComp.messagesList = res.data.messages
            if (res?.data?.messages.length == 0) {
              this.$toast.add(
              {severity:'success', 
              summary: 'Sauvegarder',
              detail:'Le billet a été sauvegardé.', 
              life: 6000});
          }    
          this.isSauvegardeEnCours = false;
        });
    },
    fermer() {
        this.$root.$refs.breadcrumbComp.rediriger();           
    },        
  },
  beforeRouteLeave (to, from, next) {
    return this.$refs.dialogConfirmation.confirmer(next, this.billet, this.$refs.modifierChamps.getBilletLocal());
  },    
};
</script>
